import {
  ACTION_SYNC_HOTEL,
  ACTION_SYNC_HOTEL_SUCCESS,
  ACTION_SYNC_HOTEL_FAILURE,
  API_CALL,
} from '../../../configs/ActionTypes';
import { Dispatch } from 'redux';
import { enqueueSnackbarHandler } from '../../Status';

export type SyncHotelPayload = {
  expediaId?: string;
  travelportId?: string;
};

export function syncHotel(data: SyncHotelPayload, onError: (message: string) => void, onSettled: () => void) {
  return (dispatch: Dispatch) => {
    dispatch({ type: ACTION_SYNC_HOTEL, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: 'sync-hotel',
        method: 'post',
        data: JSON.stringify(data),
        success: (response: any) => {
          enqueueSnackbarHandler(dispatch, { syncHotelSuccess: true }, 'success');
          dispatch({ type: ACTION_SYNC_HOTEL_SUCCESS, payload: response });
          onSettled();
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error?.payload, 'error');
          const message = error?.payload?.message ?? error?.payload ?? 'An unexpected error occurred.';
          onError(message);
          dispatch({ type: ACTION_SYNC_HOTEL_FAILURE, payload: error });
          onSettled();
        },
      },
    });
  };
}
